module.exports = __webpack_public_path__ + "static/other/diseased_trees_game_2.47ac7290.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/diseaseTreesGame/diseased_trees_game_2.json
// module id = 2361
// module chunks = 0